import { create } from "zustand";
import { persist } from "zustand/middleware";

export type AdminRole = "root" | "admin" | "support_l2" | "support_l1";

interface AuthState {
  token: string | null;
  email: string | null;
  role: AdminRole | null;
  permissions: string[];
  assumedRole: AdminRole | null;
  setAuth: (token: string, email: string, role: AdminRole, permissions: string[]) => void;
  clearAuth: () => void;
  setAssumedRole: (role: AdminRole | null) => void;
  hasPermission: (perm: string) => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: null,
      email: null,
      role: null,
      permissions: [],
      assumedRole: null,

      setAuth: (token, email, role, permissions) =>
        set({ token, email, role, permissions, assumedRole: null }),

      clearAuth: () =>
        set({ token: null, email: null, role: null, permissions: [], assumedRole: null }),

      setAssumedRole: (role) => set({ assumedRole: role }),

      hasPermission: (perm: string) => {
        const { role, assumedRole, permissions } = get();
        if (!role) return false;
        const activeRole = assumedRole ?? role;
        if (activeRole === "root") return true;
        return permissions.includes(perm);
      },
    }),
    { name: "sq-admin-auth" }
  )
);
